import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { forkJoin } from "rxjs";
import { LocationModel } from "src/app/models/location.model";
import { LocationService } from "src/app/services/location.service";
import {
    FormComponent,
    IFormDialogData,
} from "src/app/shared/form/form.component";
import { TextFormField } from "src/app/shared/form/formField.model";
import nameOf from "src/app/shared/form/nameOf.helper";

export interface ILocationDialogData extends IFormDialogData {
    groupId: string;
}

@Component({
  standalone: false,
    selector: "app-location-dialog",
    templateUrl: "./../../shared/form/form.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./../../shared/form/form.component.scss"],
})
export class LocationDialogComponent
    extends FormComponent<LocationModel>
    implements OnInit
{
    constructor(
        dialogRef: MatDialogRef<LocationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ILocationDialogData,
        locationService: LocationService,
        protected injector: Injector,
    ) {
        super(dialogRef, locationService, data, "Location", injector);
    }

    ngOnInit(): void {
        this.isFormLoading = true;
        forkJoin({
            entity: this.getEntity(),
        }).subscribe(
            (result) => {
                this.entity = result.entity;
                this.initFields();
                this.isFormLoading = false;
            },
            (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        );
    }

    getNewObject(): LocationModel {
        return new LocationModel();
    }

    validate(): boolean {
        return true;
    }

    onBeforeSave(model: LocationModel): void {
        model.locationGroupId = this.data.groupId;
    }

    initFields(): void {
        this.fields = [
            new TextFormField({
                property: nameOf<LocationModel>((x) => x.name),
                name: "Location Name",
                cssClass: "btn btn-primary",
            }),
        ];
    }
}
